import { ShieldAlert, X } from 'lucide-react';
import { useReauth } from '../../contexts/ReauthContext';

export function ReauthBanner() {
  const { state, clearReauth } = useReauth();

  if (!state.isActive) {
    return null;
  }

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-red-900/80 border-b border-red-700 px-4 py-2 text-red-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <ShieldAlert className="h-5 w-5 text-red-400 animate-pulse" />
          <span className="font-semibold">Break-Glass Mode Active</span>
          <span className="opacity-75">|</span>
          <span className="font-mono text-red-300">
            Expires in {formatTime(state.remainingSeconds)}
          </span>
        </div>

        <button
          onClick={clearReauth}
          className="flex items-center gap-1 px-2 py-1 rounded hover:bg-red-800/50 transition-colors text-sm"
          title="End break-glass session"
        >
          <X className="h-4 w-4" />
          End Session
        </button>
      </div>
    </div>
  );
}
